"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var core_1 = require("@emotion/core");

var styled_1 = __importDefault(require("@emotion/styled"));

var theme_1 = require("./theme");

var spin = core_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var containerSizeMap = {
  xs: 20,
  sm: 40,
  base: 80,
  lg: 120,
  xl: 180
};
var ringWidthSizeMap = {
  xs: 1,
  sm: 3,
  base: 6,
  lg: 9,
  xl: 14
};
var Element = styled_1["default"].div(function (props) {
  return core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n\n    &:after {\n      content: ' ';\n      display: block;\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n      border-width: ", "px;\n      border-style: solid;\n      border-top-color: inherit;\n      border-bottom-color: inherit;\n      border-right-color: transparent;\n      border-left-color: transparent;\n      animation: ", " 1.2s linear infinite;\n    }\n  "], ["\n    display: inline-block;\n    width: ", "px;\n    height: ", "px;\n\n    &:after {\n      content: ' ';\n      display: block;\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n      border-width: ", "px;\n      border-style: solid;\n      border-top-color: inherit;\n      border-bottom-color: inherit;\n      border-right-color: transparent;\n      border-left-color: transparent;\n      animation: ", " 1.2s linear infinite;\n    }\n  "])), containerSizeMap[props.size || 'base'], containerSizeMap[props.size || 'base'], ringWidthSizeMap[props.size || 'base'], spin);
});

function Loader(props) {
  var border = theme_1.useBorderColor(props.className);
  return react_1["default"].createElement(Element, __assign({}, props, {
    className: border
  }));
}

exports.Loader = Loader;
var templateObject_1, templateObject_2;